import React, { useCallback } from "react";
import { makePaginatedGet } from "@culturehq/client";
import { FeedItem } from "@culturehq/components";

import ErrorBoundary from "components/common/ErrorBoundary";
import Slideshow from "components/common/Slideshow";

import RecognitionHeader from "./recognition/RecognitionHeader";
import RecognitionMiddle from "./recognition/RecognitionMiddle";

const RecognitionSlides = ({ options }) => {
  const onFetch = useCallback(
    async () => {
      const { recognitions } = await makePaginatedGet("recognitions", "/recognitions", options);
      return recognitions;
    },
    [options]
  );

  return (
    <Slideshow onFetch={onFetch}>
      {recognition => (
        <FeedItem className="recognitions__recognition">
          <FeedItem.Body>
            <ErrorBoundary>
              <RecognitionHeader recognition={recognition} />
              <RecognitionMiddle recognition={recognition} />
            </ErrorBoundary>
          </FeedItem.Body>
        </FeedItem>
      )}
    </Slideshow>
  );
};

export default RecognitionSlides;
